import React from 'react';
import { Avatar } from '@mui/material';
import { first } from 'lodash';

/* eslint react/require-default-props: 0 */
interface PVAvatarProps {
  color?: string;
  firstName: string;
  fontSize?: number;
  height?: number;
  image?: string;
  member?: boolean;
  border?: boolean;
}

const PVAvatar = React.forwardRef(
  (
    {
      color = 'white',
      firstName = '',
      fontSize = 20,
      height = 35,
      image = undefined,
      member = true,
      border = false,
    }: PVAvatarProps,
    ref: React.Ref<any>
  ) => {
    let backgroundColor = 'primary.main';

    if (member) {
      backgroundColor = 'primary.pink';
    }

    if (image) {
      backgroundColor = 'white';
    }

    return (
      <Avatar
        src={image}
        title={firstName}
        alt={firstName}
        sx={{
          backgroundColor,
          color,
          fontSize,
          fontWeight: 700,
          height,
          width: height,
          border: border ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
        }}
        ref={ref}
      >
        {first(firstName)}
      </Avatar>
    );
  }
);

PVAvatar.displayName = 'PVAvatar';

export { PVAvatar };
